import { useMutation, useQueryClient } from "@tanstack/react-query";
import { IRenewal } from "../../utils/quoteUtils";
import { executeQuery } from "../../../utils";
import { useDeltaToastContext } from "../../../shared/contexts/ToasterContext";
import { RENEWALS_TABLE_QUERY_KEY } from "./constants";

export function useUpdateRenewal(): (
  renewalId: string,
  partialUpdatedRenewal: Partial<IRenewal>
) => Promise<void> {
  const queryClient = useQueryClient();
  const toastContext = useDeltaToastContext();

  const updateMutation = useMutation({
    mutationFn: async ({
      renewalId,
      update,
    }: {
      renewalId: string;
      update: Partial<IRenewal>;
    }) => {
      return await executeQuery({
        path: `/manager_new/renewals/${renewalId}`,
        method: "put",
        requestBody: update,
      });
    },
  });

  return (renewalId, partialUpdatedRenewal) => {
    const update: Partial<IRenewal> = {
      ...partialUpdatedRenewal,
    };
    if (update.renewalCleared === true) {
      const { email } = JSON.parse(localStorage.getItem("user") || "{}");
      update.manuallyClearedBy = { email, time: Date.now() };
    }
    return new Promise((resolve, reject) => {
      updateMutation.mutate(
        { renewalId, update },
        {
          onSuccess: ({ success, message }) => {
            queryClient.invalidateQueries({
              queryKey: [RENEWALS_TABLE_QUERY_KEY],
            });

            toastContext.addToast({
              status: success ? "Success" : "Error",
              message: success
                ? "Renewal updated"
                : message ?? "Error updating renewal",
            });

            if (success) {
              resolve();
            } else {
              reject();
            }
          },
          onError: (error) => {
            const message = typeof error === "string" ? error : error.message;
            queryClient.invalidateQueries({
              queryKey: [RENEWALS_TABLE_QUERY_KEY],
            });
            toastContext.addToast({
              status: "Error",
              message: `Error updating renewal: ${message}`,
            });

            reject();
          },
        }
      );
    });
  };
}
